import { IconProps } from './icons-props';

function Menu({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            fill='none'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M3 12H21M3 6H21M9 18H21'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}

export default Menu;

